import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';


declare let $: any

@Component({

  selector: 'app-active-rent',

  templateUrl: './active-rent.component.html',

  styleUrls: ['./active-rent.component.css']

})

export class ActiveRentComponent implements OnInit {

  lst_ActiveRent: any = [];

  lst_Search: any = [];

  lst_Vehicle: any = [];

  lst_Collateral: any = [];

  obj_RentInfo: any = {};

  obj_RentAnalysis: any = {};

  obj_RentRoute: any = {};

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iRent: new FormControl('')

  })

  mdl_Rent: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strID: new FormControl('', Validators.required),

    strFullName: new FormControl(''),

    strMobile: new FormControl('', Validators.required),

    iRentCount: new FormControl({ value: '', disabled: true }),

    iRentDamage: new FormControl({ value: '', disabled: true }),

    iCode: new FormControl('', Validators.required),

    iCost: new FormControl('0'),

    tiRent_CollateralType: new FormControl('', this._otherService.zeroOrMoreValidator),

    strComment: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getRent_List();

  }

  async getRent_List() {

    // -------------------------------------

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Rent_Open_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_ActiveRent = res;

    this.lst_Search = res;

    // -------------------------------------

    this._otherService.Showspinner();

    let res_2 = JSON.parse((await axios.post(`Rent_Mobile4Rent`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res_2.iResult == 0) return this._tooltip.showError(res_2.strError);

    this.lst_Vehicle = res_2;

    // -------------------------------------

    this._otherService.Showspinner();

    let res_3 = JSON.parse((await axios.post(`Rent_CollateralType_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res_3.iResult == 0) return this._tooltip.showError(res_3.strError);

    this.lst_Collateral = res_3;



  }

  filter_list(val: any) {

    this.lst_ActiveRent = this.lst_Search.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strMobile.toString().includes(val.value) ||

        el.iCode.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_ActiveRent = this.lst_Search;

    }

  }

  showOnMap(item: any) {

    window.open(`/tracker/${item.strUnitID}`, '_blank')

  }

  async showReport(item: any) {

    this.obj_RentRoute = item;

    this.mdl_Search.controls['iRent'].setValue(item.iRent)

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Rent_Report_Live`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.obj_RentInfo = res[0];

    $("#RentInfo_Modal").modal('show');

  }

  async showDeliver(item: any) {

    this.mdl_Search.controls['iRent'].setValue(item.iRent)

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Rent_Analysis`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.obj_RentAnalysis = res[0];

    $("#RentAnalysis_Modal").modal('show');

  }

  async endDelivery() {

    if (this.obj_RentAnalysis.bDamage && (this.obj_RentAnalysis.iDamageCost == '0' || this.obj_RentAnalysis.iDamageCost.trim() == '')) {

      return this._tooltip.showError('مبلغ خسارت را وارد کنید')

    }

    else {

      if (this.obj_RentAnalysis?.iDamageCost.toString().includes(',')) {

        this.obj_RentAnalysis.iDamageCost = this.obj_RentAnalysis.iDamageCost.toString().replace(/,/g, '');

      }

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Rent_Return`, this._otherService.stringNumberToNumber(this.obj_RentAnalysis))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      $("#RentAnalysis_Modal").modal('hide');

      // حذف از لیست

      this.lst_ActiveRent = this.lst_ActiveRent.filter((a: any) => {

        return a.iRent !== this.obj_RentAnalysis.iRent;

      })

      return this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

    }

  }

  openNewRent_Modal() {

    this.mdl_Rent.patchValue({

      strID: '',

      strFullName: '',

      strMobile: '',

      iRentCount: '',

      iRentDamage: '',

      iCode: '',

      iCost: '0',

      strComment: '',

      tiRent_CollateralType: ''

    })

    $("#Rent_Modal").modal("show");

  }

  async checkOut_Rent() {

    if (this.mdl_Rent.get('strID')?.value == '' && this.mdl_Rent.get('strMobile')?.value == '') {

      return this._tooltip.showError('لطفا کد ملی یا شماره موبایل را وارد کنید');

    }

    if (this.mdl_Rent.get('strID')?.value.trim() != '' && this.mdl_Rent.get('strID')?.value.length < 10) {

      return this._tooltip.showError('کد ملی وارد شده صحیح نمی باشد');

    }

    if (this.mdl_Rent.get('strMobile')?.value.trim() != '' && this.mdl_Rent.get('strMobile')?.value.length < 11) {

      return this._tooltip.showError('شماره موبایل وارد شده صحیح نمی باشد');

    }

    else {

      // $("#Rent_Modal").modal("hide");

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Rent_Query`, this._otherService.stringNumberToNumber(this.mdl_Rent.value))).data.toString());

      this._otherService.nonespinner();

      // $("#Rent_Modal").modal("show");

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      Object.keys(res[0]).forEach(key => {

        this.mdl_Rent.get(key)?.setValue(res[0][key])

      })

    }

  }

  async save_NewRent() {

    if (this.mdl_Rent.invalid) return this._tooltip.showError('لطفا موارد ضروری را با دقت تکمیل کنید');

    else {

      this.mdl_Rent.get('iCost')?.setValue(this.mdl_Rent.get('iCost')?.value.replace(/,/g, ''));

      $("#Rent_Modal").modal('hide');

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Rent_Save`, this._otherService.stringNumberToNumber(this.mdl_Rent.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) {

        $("#Rent_Modal").modal('show');

        return this._tooltip.showError(res.strError);

      }

      this.lst_ActiveRent.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ثبت شد')

      $("#Rent_Modal").modal('hide');

    }

    // Rent_Save

  }

  showRoute(item: any) {

    window.open(`route/${item.strUnitID}`, '_blank')

    const RETURN_DATE = item?.strReturn_Date.trim() != '' ? item.strReturn_Date : moment().format('jYYYY/jMM/jDD')

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(RETURN_DATE));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strRent_Time));

    const RETURN_TIME = item?.strReturn_Time.trim() != '' ? item.strReturn_Time : moment().format('HH:mm:ss')

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(RETURN_TIME));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(item.strUnitID.toString()));

    window.localStorage.setItem("carName", this.gurdService.encrypt(item.strMobile_strFullName.toString()));

    // window.localStorage.setItem("plate", this.gurdService.encrypt(item.strVehicleNo?.toString()));

  }

}
